import type { PlanSettings } from "building-types/settings/planSettings";
import { defaultPlanSettings } from "doc/settings/defaultSettings";
import type { FontSizes } from "pdf/planFonts";
import {
  DEFAULT_EXTRALARGE_FONT_SIZE,
  DEFAULT_LARGE_FONT_SIZE,
  DEFAULT_MEDIUM_FONT_SIZE,
  DEFAULT_MEDIUMLARGE_FONT_SIZE,
  DEFAULT_REGULAR_FONT_SIZE,
  DEFAULT_SMALL_FONT_SIZE,
  preciseToLegacyPlanFontSize,
} from "pdf/planFonts";

const preciseFontSizes: FontSizes = {
  small: DEFAULT_SMALL_FONT_SIZE,
  regular: DEFAULT_REGULAR_FONT_SIZE,
  medium: DEFAULT_MEDIUM_FONT_SIZE,
  mediumLarge: DEFAULT_MEDIUMLARGE_FONT_SIZE,
  large: DEFAULT_LARGE_FONT_SIZE,
  extraLarge: DEFAULT_EXTRALARGE_FONT_SIZE,
};

const legacyFontSizes: FontSizes = {
  small: preciseToLegacyPlanFontSize(preciseFontSizes.small),
  regular: preciseToLegacyPlanFontSize(preciseFontSizes.regular),
  medium: preciseToLegacyPlanFontSize(preciseFontSizes.medium),
  mediumLarge: preciseToLegacyPlanFontSize(preciseFontSizes.mediumLarge),
  large: preciseToLegacyPlanFontSize(preciseFontSizes.large),
  extraLarge: preciseToLegacyPlanFontSize(preciseFontSizes.extraLarge),
};

export function planSettingsGetFontSizes(planSettings: PlanSettings): FontSizes {
  // undefined settings can happen during plan template export.
  const safePlanSettings = planSettings.enableLegacyFontScaling === undefined ? defaultPlanSettings : planSettings;
  return safePlanSettings.enableLegacyFontScaling ? legacyFontSizes : preciseFontSizes;
}
